<mat-form-field appearance="fill">
    <mat-label>{{ 'select_account' | translate }}</mat-label>
    <input
      matInput
      [formControl]="serviceCtrl"
      [matAutocomplete]="auto" required>
  
    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="serviceSelected($event)" [displayWith]="autocompleteDisplay">
      <mat-option *ngFor="let account of filteredAccounts" [value]="account"
        [matTooltip]="account.account_name" matTooltipPosition="right">
        {{account.account_name}}
      </mat-option>
      <mat-divider></mat-divider>
      <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-flat-button (click)="clear()">
          <mat-icon>clear</mat-icon>
          {{ 'clear' | translate }}
        </button>
      </div>
    </mat-autocomplete>
  </mat-form-field>
  
  
  